// src/app/services/theme.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ConfigService } from './config.service';
const defaultTheme = '_default';
@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private renderer: Renderer2;
    private themeLinkId = 'client-theme';

    constructor(
        private rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        
    }

    public loadTheme(cliente: string): void {
        console.log(`Loading theme for client: ${cliente}`);
        
        if (!cliente || cliente.trim() === '') {
            cliente = defaultTheme;
        }
        const head = document.head;
        const existingLink = document.getElementById(this.themeLinkId);
        const themePath = `assets/themes/${cliente}.variables.css`;

        if (existingLink) {
            existingLink.setAttribute('href', themePath);
        } else {
            const link = this.renderer.createElement('link');
            link.id = this.themeLinkId;
            link.rel = 'stylesheet';
            link.href = themePath;
            this.renderer.appendChild(head, link);
        }
    }
}
// This service dynamically loads a CSS theme based on the provided client name.